<dashboardnav>
  <cradua-incident-quantum [incidentquantums]="incidentquantums$ | async"
    (incidentquantum)="onSubmitIncidentQuantum($event)" (deleteIncidentQuantumEvent)="onDeleteIncidentQuantum($event)"
    *ngIf="(isLoadingIncidentQuantum$ | async ) === false">
  </cradua-incident-quantum>

  <mrsoftapps-epims-reference-spinner *ngIf="(isLoadingIncidentQuantum$ | async) === true">
  </mrsoftapps-epims-reference-spinner>
  <!-- <pre>{{isLoading$ | async | json}}</pre> -->
</dashboardnav>
